// @flow
import * as React from 'react';
import { SearchableSelect } from 'components/Select';
import Field from './Field';

const SelectField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  options: Array<{ value: string, label: string }>
}) => (
  <Field
    inputProps={props}
    name={name}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => (
      <SearchableSelect
        className={qaId}
        id={id}
        name={name}
        value={value || ''}
        hasError={hasError}
        onChange={updateValue}
        label={label}
        searchable
        {...props}
      />
    )}
  />
);

export default SelectField;
